module.exports = __webpack_public_path__ + "img/justice-john-marshall-harlan.6477ce29.png";